<template>
  <transition name="slide-from-right">
    <aside
      v-if="sidebarOpen"
      class="sidebar"
    >
      <focus-lock>
        <slot />
      </focus-lock>
    </aside>
  </transition>
</template>

<script>
import bus from './../bus';
export default {
  data: function () {
    return {
      sidebarOpen: false,
    };
  },
  mounted() {
    bus.$on('sidebarOpen', (data) => {
      this.sidebarOpen = data;
    });
  },
};
</script>
